:host {
	display: flex;
	flex-direction: column;
	margin-top: 2em;
	margin-bottom: 10rem;
}

:host .select-div-row {
	display: flex;
}

:host .select-div-row smoothly-input {
 flex: 1;
}

smoothly-input-demo-standard {
	margin-bottom: 2rem;
}

div.inputs {
	max-width: min(calc(100% - 2rem), 56rem);
	margin: auto;
}

div.inputs>h2:not(:first-child) {
	padding-top: 3em;
	margin-top: 3em;
	border-top: 1px solid black;
}

.checkbox-group {
	display: flex;
	gap: 1.5em;
	align-items: center;
	background-color: rgb(var(--smoothly-input-background));
}

.select-div {
	display: flex;
	/* justify-content: space-between; */
	gap: 1em;
	flex-wrap: wrap;
}

.select-div>* {
	flex-grow: 1;
	min-width: min(100%, var(--smoothly-form-input-min-width, 18rem));
	flex-basis: 40%;
}
